(function () {
	'use strict';

	// Navbar JS
	try {
		const nav = document.querySelector('.navbar');
		let navTop = nav.offsetTop;

		function fixedNav() {
			if (window.scrollY >= navTop) {
				nav.classList.add('sticky');
			} else {
				nav.classList.remove('sticky');
			}
		}

		window.addEventListener('scroll', fixedNav);
	} catch (err) {}

	// Header Sticky Js
	window.addEventListener('scroll', (event) => {
		const height = 150;
		const { scrollTop } = event.target.scrollingElement;
		document.querySelector('#navbar').classList.toggle('sticky', scrollTop >= height);
	});

	// Animation Js
	scrollCue.init();

	// Preloader Js
	window.onload = function () {
		// Preloader
		const getPreloaderId = document.getElementById('preloader');
		if (getPreloaderId) {
			getPreloaderId.style.display = 'none';
		}
	};

	// Function to check if an element is in the viewport
	function isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		const windowWidth = window.innerWidth || document.documentElement.clientWidth;

		const vertInView = rect.top <= windowHeight && rect.bottom >= 0;
		const horInView = rect.left <= windowWidth && rect.right >= 0;

		return vertInView && horInView;
	}

	// Select the button element Js
	const scrollTopBtn = document.getElementById('scrollTopBtn');

	// Ensure scrollTopBtn exists before proceeding
	if (scrollTopBtn) {
		// Show the button when the user scrolls down
		window.addEventListener('scroll', function () {
			// Check if scroll position is past 20px to show the button
			if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
				scrollTopBtn.style.display = 'block';
			} else {
				scrollTopBtn.style.display = 'none';
			}
		});

		// Add a click event listener to the button
		scrollTopBtn.addEventListener('click', function () {
			// Scroll to the top of the document
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		});
	}

	// Select the main tag and its first child div
	const mainElement = document.querySelector('main');
	const firstSectionDark = mainElement?.querySelector('section.js-top-content-dark');
	const headerColourSwitch = document.querySelector('.header-colour-switch');
	// Ensure firstSection and headerColourSwitch exist before proceeding
	if (firstSectionDark && headerColourSwitch) {
		// Add the 'js-header-dark' class to the .header-colour-switch element
		headerColourSwitch.classList.add('js-header-dark');
		headerColourSwitch.style.setProperty('--header-colour-switch-border-bottom', '1px solid transparent');

		// Function to handle the visibility of js-header-dark
		function handleHeaderDarkVisibility() {
			if (firstSectionDark && !isElementInViewport(firstSectionDark)) {
				// outside first component with dark bg
				headerColourSwitch.classList.remove('js-header-dark');
			} else {
				// inside first component with dark bg
				headerColourSwitch.classList.add('js-header-dark');
			}
		}

		// Event listeners for scroll and resize
		window.addEventListener('scroll', handleHeaderDarkVisibility);
		window.addEventListener('resize', handleHeaderDarkVisibility);

		// Initial check on page load
		handleHeaderDarkVisibility();
	} else if (headerColourSwitch) {
		headerColourSwitch.style.setProperty(
			'--header-colour-switch-border-bottom',
			'1px solid var(--color-light-silver)'
		);
	}

	const seoStage = document.querySelector('.seo-stage');
	if (seoStage) {
		function setBgSeoStageHeight() {
			const seoStageContainer = document.querySelector('.seo-stage');
			const imgSeoStage = document.querySelector('.js-img-seo-stage');

			if (seoStageContainer && imgSeoStage) {
				const seoStageContainerHeight = seoStageContainer.offsetHeight;
				const imgSeoStageHeight = imgSeoStage.offsetHeight;
				const viewportWidth = window.innerWidth;

				let imgSeoStageMb = 16; // Default values
				let seoStagePb = 16; // Default values

				if (viewportWidth >= 992) {
					imgSeoStageMb = 60;
					seoStagePb = 60;
				} else if (viewportWidth >= 576) {
					imgSeoStageMb = 60;
					seoStagePb = 16;
				}
				// Calculate the background height
				const bgSeoStageHeight = seoStageContainerHeight - (imgSeoStageHeight / 2 + imgSeoStageMb + seoStagePb);

				// Apply the calculated height to the :before pseudo-element
				seoStage.style.setProperty('--bg-seo-stage-height', `${bgSeoStageHeight}px`);
			}
		}

		// Set height on scroll and resize events
		window.addEventListener('scroll', setBgSeoStageHeight);
		window.addEventListener('resize', setBgSeoStageHeight);

		// Initial call
		setBgSeoStageHeight();
	}

	document.addEventListener('DOMContentLoaded', () => {
		// Ensures anchor links work correctly after closing the offcanvas menu.
		document.querySelectorAll('[data-target-anchor]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				const target = btn.getAttribute('data-target-anchor');
				const offcanvasEl = btn.closest('.offcanvas');

				if (offcanvasEl) {
					offcanvasEl.addEventListener('hidden.bs.offcanvas', function handleHide() {
						window.location.href = target;
						// Remove the listener after firing to prevent duplicates
						offcanvasEl.removeEventListener('hidden.bs.offcanvas', handleHide);
					});
				}
			});
		});

		// Ensures the offcanvas menu closes after clicking anchor link menu.
		const links = document.querySelectorAll('.accordion-link[href*="#"]');

		links.forEach((anchor) => {
			anchor.addEventListener('click', function (e) {
				// ✅ Skip modal popup links
				if (anchor.classList.contains('js-modal-link') || anchor.hasAttribute('data-modal')) {
					return; // let modal JS handle it
				}

				const href = anchor.getAttribute('href');
				if (!href || !href.includes('#')) {
					return;
				}

				let url;
				try {
					url = new URL(href, window.location.origin);
				} catch {
					return;
				}

				if (url.origin !== location.origin) {
					return;
				}

				const offcanvasEl = anchor.closest('.offcanvas');
				if (!offcanvasEl) {
					return;
				}

				e.preventDefault();

				const handleHide = () => {
					window.location.href = url.pathname + url.hash;
					offcanvasEl.removeEventListener('hidden.bs.offcanvas', handleHide);
				};

				offcanvasEl.addEventListener('hidden.bs.offcanvas', handleHide);

				const dismissBtn = offcanvasEl.querySelector('[data-bs-dismiss="offcanvas"]');
				if (dismissBtn) {
					dismissBtn.click();
				}
			});
		});

		// bc form links
		const bcFilter = document.querySelector('.js-bc-filter');

		if (bcFilter) {
			const productTypeSelect = document.getElementById('productType');
			const businessAddressSelect = document.getElementById('js-business-address-location');
			const officeSelect = document.getElementById('js-office-location');
			const conferenceRoomSelect = document.getElementById('js-conference-room-location');
			const form = document.getElementById('product-location-form');

			// Check if window.page.product exists and preselect the value on the first selection option
			if (window.page && window.page.product) {
				productTypeSelect.value = window.page.product;
				// Trigger change event to update location selects
				productTypeSelect.dispatchEvent(new Event('change'));
			}
			const allAdvancedContainers = document.querySelectorAll('.col-location .advanced-select-container');
			const showMatchingLocationSelect = (selectedProductType) => {
				// Show the appropriate advanced-select-container based on the product type
				let selectedContainer;
				switch (selectedProductType) {
					case 'business address':
						selectedContainer = businessAddressSelect.closest('.advanced-select-container');
						break;
					case 'office':
						selectedContainer = officeSelect.closest('.advanced-select-container');
						break;
					case 'conference room':
						selectedContainer = conferenceRoomSelect.closest('.advanced-select-container');
						break;
				}
				if (selectedContainer) {
					allAdvancedContainers.forEach((advancedContainer) => {
						advancedContainer.style.display = 'none';
					});
					selectedContainer.style.display = 'block'; // Show the container for the selected product type
				}
			};

			// On page load, show the appropriate location select if productType is pre-selected
			if (productTypeSelect.value) {
				showMatchingLocationSelect(productTypeSelect.value);
			}

			// Listen to changes in the product type select
			productTypeSelect.addEventListener('change', () => {
				const selectedProductType = productTypeSelect.value;
				showMatchingLocationSelect(selectedProductType);
			});

			// Handle click on the display-option
			document.querySelectorAll('.js-bc-filter .display-option').forEach((displayOption) => {
				displayOption.addEventListener('click', () => {
					if (!displayOption.classList.contains('active')) {
						displayOption.classList.add('active');
					}
				});
			});

			// Update the show/hide behavior when advanced custom selection UI is interacted with
			document.querySelectorAll('.js-bc-filter .select-options').forEach((optionList) => {
				optionList.addEventListener('click', (event) => {
					const selectedOption = event.target;

					if (selectedOption && selectedOption.tagName.toLowerCase() === 'li') {
						const parentContainer = selectedOption.closest('.advanced-select-container');
						const displayOption = parentContainer.querySelector('.display-option');
						displayOption.classList.add('active');
						// Set the value and text in the advanced select UI
						displayOption.textContent = selectedOption.textContent;
						parentContainer.querySelector('input').value = selectedOption.dataset.value;

						// Remove active class from all and add it to the clicked option
						parentContainer.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
						selectedOption.classList.add('active');

						// Show the corresponding location select based on the new product type selection
						showMatchingLocationSelect(selectedOption.dataset.value);
					}
				});
			});

			// Handle form submission
			form.addEventListener('submit', (event) => {
				event.preventDefault(); // Prevent default form submission
				const selectedProductType = productTypeSelect.value;
				let selectedLocationInput;

				// Check which select element is currently visible based on the selected product type
				switch (selectedProductType) {
					case 'business address':
						selectedLocationInput = document.querySelector('input[name="business address location"]');
						break;
					case 'office':
						selectedLocationInput = document.querySelector('input[name="office location"]');
						break;
					case 'conference room':
						selectedLocationInput = document.querySelector('input[name="conference room location"]');
						break;
				}

				if (selectedLocationInput && selectedLocationInput.value) {
					const selectedLocationValue = selectedLocationInput.value;
					if (selectedLocationValue) {
						// Redirect the browser to the URL in the selected option's value
						window.location.href = selectedLocationValue;
					} else {
						console.error('No valid location selected.');
					}
				} else {
					console.error('No location input is visible.');
				}
			});
		}

		function setEditorialOlHeight() {
			const editorialOl = document.querySelector('.editorial ol');

			if (editorialOl) {
				const editorialListItems = editorialOl.querySelectorAll('li');
				if (editorialListItems.length > 1) {
					let totalHeight = 0;
					// Calculate the total height of all <li> except the last one
					for (let i = 0; i < editorialListItems.length - 1; i++) {
						totalHeight += editorialListItems[i].offsetHeight;
					}
					// Add 69px to the calculated total height
					const adjustedHeight = totalHeight + 69;
					// Apply the height to the ::before pseudo-element
					editorialOl.style.setProperty('--editorial-ol-border-height', `${adjustedHeight}px`);
				}
			}
		}

		// Set height on scroll and resize events
		window.addEventListener('scroll', setEditorialOlHeight);
		window.addEventListener('resize', setEditorialOlHeight);

		// Initial call
		setEditorialOlHeight();
	});

	// Experience Component -  Slider Js
	document.querySelectorAll('.js-experience-slider').forEach((container) => {
		new Swiper(container, {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			navigation: {
				nextEl: '.experience-button-next',
				prevEl: '.experience-button-prev',
			},
		});
	});

	// Industry Component - Slider Js
	document.querySelectorAll('.js-industry-slider').forEach((container) => {
		new Swiper(container, {
			slidesPerView: 1,
			spaceBetween: 30,
			centeredSlides: false,
			loop: false,
			roundLengths: true,
			navigation: {
				nextEl: '.industry-button-next',
				prevEl: '.industry-button-prev',
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				992: {
					slidesPerView: 4,
				},
				1200: {
					slidesPerView: 5,
				},
				1400: {
					slidesPerView: 6,
				},
			},
		});
	});

	document.querySelectorAll('.js-stage-slider').forEach((container) => {
		new Swiper(container, {
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
			navigation: {
				nextEl: '.stage-button-next',
				prevEl: '.stage-button-prev',
			},
			loop: false,
		});
	});

	document.querySelectorAll('.js-image-slider').forEach((container) => {
		const pagination = container.dataset.swiperPagination === 'true';

		new Swiper(container, {
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 32,
				},
			},
			navigation: {
				nextEl: '.js-image-slider-button-next',
				prevEl: '.js-image-slider-button-prev',
			},
			pagination: pagination,
			loop: false,
		});
	});

	document.querySelectorAll('.js-logo-slider').forEach((container) => {
		new Swiper(container, {
			slidesPerView: 3,
			spaceBetween: 20,
			breakpoints: {
				320: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 4,
					spaceBetween: 32,
				},
				1200: {
					slidesPerView: 6,
					spaceBetween: 32,
				},
			},
			navigation: false,
			pagination: false,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			speed: 800,
			effect: 'slide',
			grabCursor: true,
		});
	});
})();
